// Released for authenticated accounts; explicit false remains an emergency build switch.
export const PET_ENABLED = import.meta.env.VITE_TEACHERS_PET_ENABLED !== 'false';
